import { INLINES } from '@contentful/rich-text-types';

const renderOptions = {
    renderText: text =>
        text.split('\n').reduce((children, textSegment, index) => {
            return [
                ...children,
                index > 0 && <br key={index} />,
                textSegment
            ];
        }, []),
    renderNode: {
        [INLINES.HYPERLINK]: (node, children) => {
            const { uri } = node.data;
            return (
                <a href={uri} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            );
        },
    },
};

export default renderOptions;
